import { Bar } from 'vue-chartjs'

export default {
  name: 'ComboBarLineDualAxisChart',
  extends: Bar,
  props: {
    chartJs: { type: Object, required: true },
  },
  mounted() {
    this.render()
  },
  watch: {
    chartJs: {
      deep: true,
      handler() {
        this.render()
      },
    },
  },
  methods: {
    render() {
      this.renderChart(this.chartJs.data, this.chartJs.options)
    },
  },
}
